import { all, takeEvery, put, fork } from 'redux-saga/effects';
import {
	AUTH_TOKEN,
	FIRST_NAME,
	LAST_NAME,
	LN_ID,
	DEPT_ID,
	DEPT_DESCRIPTION,
	AVATAR,
	ENDORSABLE,
	ROLE,
	NAV_ROLE_SECTIONS,
	PATH_ROLE_SECTIONS,
	SIGNOUT,
	APPLICATION
} from '../constants/Auth';
import {
	showAuthMessage
} from "../actions/Auth";

export function* signOut() {
  yield takeEvery(SIGNOUT, function* () {
		try {
			if (true) {//signOutUser === undefined) {
				localStorage.removeItem(AUTH_TOKEN);
				localStorage.removeItem(FIRST_NAME);
				localStorage.removeItem(LAST_NAME);
				localStorage.removeItem(DEPT_ID);
				localStorage.removeItem(DEPT_DESCRIPTION);
				localStorage.removeItem(AVATAR);
				localStorage.removeItem(ENDORSABLE);
				localStorage.removeItem(LN_ID);
				localStorage.removeItem(APPLICATION);
				
				localStorage.removeItem(ROLE);
				localStorage.removeItem(NAV_ROLE_SECTIONS);
				localStorage.removeItem(PATH_ROLE_SECTIONS);
				window.location.href="/auth/login"
				//yield put(signOutSuccess(signOutUser));
			} else {
				yield put(showAuthMessage("ERR"));//signOutUser.message));
			}
		} catch (err) {
			yield put(showAuthMessage(err));
		}
	});
}

export default function* rootSaga() {
  yield all([
		fork(signOut)
  ]);
}
